import { QueryClient } from "@tanstack/react-query";
import { LoaderFunctionArgs } from "react-router";
import { PARTNERS_QUERIES } from "~/shared/api/partners/partners.queries";

export async function partnerEditLoader({ params }: LoaderFunctionArgs, queryClient: QueryClient) {
  const { partnerId } = params;

  if (!partnerId) {
    throw new Error("Partner ID is required");
  }

  queryClient.prefetchQuery(PARTNERS_QUERIES.detail(partnerId));

  return null;
}
